import { Map } from 'immutable'

const groupBy = <k, a>(keySelector: (_: a) => k, arr: a[]) =>
  arr.reduce((m, x) => m.update(keySelector(x), [], (xs) => [...xs, x]), Map<k, a[]>())

export type Alphabetized<a> = {
  letter: string
  items: a[]
}[]

export const alphabetize = <a>(letterSelector: (_: a) => string, arr: a[]): Alphabetized<a> =>
  groupBy(
    (x) => (letterSelector(x) ? letterSelector(x)[0] : '?'),
    arr.sort((x, y) => letterSelector(x).localeCompare(letterSelector(y)))
  )
    .toArray()
    .map(([letter, items]) => ({
      letter,
      items,
    }))
